/* istanbul ignore file */

export const addFitAnalyticsObject = async ({ language, country, product, shopSessionId, metaData, selectItem, fitAnalytics }) => {
    const colourArray = product?.colourSwatches.map(({ partNumber }) => partNumber);
    const sKUs = product?.sKUs;
    const size = product?.size?.centralSizeLabel;
    const sizesArray = sKUs
        ? sKUs.map((skuItem) => ({
              value: skuItem.size?.centralSizeLabel || skuItem.size?.labelSize,
              isAvailable: skuItem.buyable && !skuItem.soldOutOnline,
              partNumber: skuItem.partNumber,
          }))
        : [];

    const { personalizationID } = (await window.SF?.getUserSummary()) || {};

    const PDPObject = {
        shopLanguage: language,
        shopCountry: country,
        mainImageLink: metaData?.og?.image,
        user: {
            id: personalizationID,
            hasLoggedIn: personalizationID ? true : false,
        },
        currentItemSubgroupId: product?.colourPartNumber,
        allItemSubgroupIds: colourArray,
        shopSessionId: shopSessionId,
        experimentFunnel: 'control',
        sizes: sizesArray,
        consent: {
            hasAnalyticsConsent: () => {
                return new Promise((resolve, reject) => {
                    if (typeof window.cact !== 'undefined') {
                        try {
                            window.cact('consent.get', ({ consent }) => {
                                const fitAnalyticsCategory = consent.categories[fitAnalytics.privacyId] || {};
                                if (fitAnalyticsCategory.status === 'on') {
                                    resolve(true);
                                } else {
                                    resolve(false);
                                }
                            });
                        } catch (error) {
                            reject(false);
                        }
                    } else {
                        resolve(false);
                    }
                });
            },
        },
        operations: {
            getAddToCartBtn: () => document.querySelector('button[class*=__addToBag].primaryButton'),
            getSizeChartLink: () => document.querySelector('a[class*=__sizeGuideLink]'),
            addToCart: async (partNumber, size) => {
                const skuPartNumber = sizesArray.find((sku) => sku.value === size).partNumber;
                await window?.SF?.addToBag({ partNumber: skuPartNumber, quantity: 1 });
                return;
            },
            selectSize: (partNumber, size) => {
                const skuPartNumber = sizesArray.find((sku) => sku.value === size).partNumber;
                selectItem(skuPartNumber, size);
            },
            getCurrentSize: () => {
                return size;
            },
            getCartItems: async () => {
                const { orderItem } = (await window.SF?.getCart()) || {};
                return orderItem.map((item) => ({
                    itemSubgroupId: item.catalogEntryView?.productColours?.[0]?.partNumber,
                    size: item.catalogEntryView?.productColours?.[0]?.sKUs?.[0]?.size?.centralSizeLabel,
                }));
            },
        },
    };

    window.fitAnalyticsData = PDPObject;
};
